<template>
  <div class="rounded">
    <div class="bg-base d-center-start pt-3 pb-3 pl-2 pr-2">
      <i class="iconfont text-blue" style="font-size: 24px;">&#xe6b9;</i>
      <h4 class="mb-0 ml-2 mr-2 font-weight-bold">{{OrderDetail.viewpointTitle || OrderDetail.store_name}}（团队票）</h4>
    </div>
    <div class="p-4">
      <div class="wait" :class="{'bgsucc': OrderDetail.status == 9}">{{OrderDetail.status | formatVar('SOrderStatus')}}</div>
      <div class="w-20 d-flex d-center-between ml-auto mr-auto mt-5 mb-5 h4" v-if="OrderDetail.status == 9">
        <div class="text-link" @click="$router.push('/index/index_scenic/scenic_detail/' + OrderDetail.appoint)">返回详情页</div>
        <div class="text-link" @click="$router.push('/index/index_scenic')">回到首页</div>
      </div>
      <div class="d-flex d-center-between border-bottom pb-2 mb-3">
        <label>订单号：{{OrderDetail.oid}}</label>
        <label>{{OrderDetail.status == 9 ? '已' : '待'}}付金额：<span class="h4 text-danger">&yen;{{OrderDetail.price}}</span></label>
      </div>
      <el-table :data="OrderDetail.ticket" style="width: 100%">
        <el-table-column label="门票种类">
          <template slot-scope="scope">
            <span>{{scope.row.ticket_species | formatVar('ticketTypeArr')}}</span>
            <span class="ml-1">（{{scope.row.ticket_name}}）</span>
          </template>
        </el-table-column>
        <el-table-column prop="scene_date" label="场次" />
        <el-table-column label="单价">
            <template slot-scope="scope">{{scope.row.univalent}} 元</template>     
        </el-table-column>
        <el-table-column prop="num" label="数量" />
        <el-table-column label="在线立减">
            <template slot-scope="scope">{{(scope.row.num * Number(scope.row.discount)).toFixed(2)}} 元</template>     
        </el-table-column>
        <el-table-column label="总计">
          <template slot-scope="scope">{{scope.row.price}}元</template>    
        </el-table-column>
      </el-table>
      <div class="d-flex d-center-between pt-4 pb-4 mt-4 pl-2 pr-2 bg-light-muted">
        <div>日期：{{OrderDetail.time | formatTimestamp(1)}}</div>
        <div>客源地：{{OrderDetail.source_province_name + OrderDetail.source_city_name}}</div>
        <div>联系人姓名：{{OrderDetail.occupant_name}}</div>
        <div>手机号：{{OrderDetail.occupant_mobile}}</div>
      </div>
      <div class="text-left">备注:{{OrderDetail.remark}}</div>
      <div class="w-30 d-flex d-center-between ml-auto mr-auto mt-5 mb-5" v-if="OrderDetail.status != 9">
        <el-button size="small" @click="$router.push('/index/index_scenic/scenic_detail/' + OrderDetail.appoint)">返回详情页</el-button>
        <el-button size="small" @click="$router.push('/index/index_scenic')">回到首页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions,mapState,mapMutations } from 'vuex'
  import SelectCity from '../../../../components/FormComp/SelectCity';

  export default {
    name: 'ScenicGroupTicket',
    components: {SelectCity},
    computed: {
      ...mapState(['OrderDetail','newMessageInform']),
    },
    watch: {
      newMessageInform(newVal) {
        if (this.newMessageInform.type === 28 || this.newMessageInform.type === 12) this.getScenicOrderDetail(this.$route.query.orderId)
      },
    },
    mounted () {
      //更新当前查看门店id
      this.UPDATECURRENTSTORE({ storeId: this.$route.query.storeId })
      this.getScenicOrderDetail(this.$route.query.orderId)
    },
    beforeDestroy() {
      //更新当前查看门店id
      this.UPDATECURRENTSTORE({ storeId: '' })
    },
    methods: {
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getScenicOrderDetail']),
    }
  }
</script>
<style scoped lang="scss">
.wait{
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  margin: 30px auto;
  border-radius: 50%;
  background-color: #f8f8f8;
}
.bgsucc{
  background: url("/images/public/succ.png") no-repeat center;
  background-size: 100%;
  width: 400px;
  height: 200px;
  color: var(--smtc-color-primary)
}
</style>
